const statusRascunho = {
  ANSWERED: 'ATENDIDO',
  INCOMPATIBLE_FACTORY: 'CENTRO INCORRETO',
  INCOMPLETE_DATA: 'SEM CADASTRO',
  INCONSISTENT_STATUS: 'STATUS MATERIAL',
  OUT_MINIMUM_ITEM: 'FORA ITEM MÍNIMO',
  OUT_MINIMUM_ORDER: 'FORA PEDIDO MÍNIMO',
  OUT_OF_STOCK: 'SEM ESTOQUE',
  WITHOUT_QUOTA: 'SEM COTA',
}

export default statusRascunho
